// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import Typography, { TypographyPresentationProps } from "@store/MobiusOverrides/Typography/Typography";
import useExpandProps, { ExpandStyles } from "@toolkit/Framework/Common/Hooks/useExpandProps";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React, { FC } from "react";
import { css } from "styled-components";

export interface AvailableAtOtherShipToLabelPresentationProps extends ExpandStyles<AvailableAtOtherShipToLabelStyles> {}

export interface AvailableAtOtherShipToLabelProps extends AvailableAtOtherShipToLabelPresentationProps {}

export interface AvailableAtOtherShipToLabelStyles {
    wrapper?: InjectableCss;
    text?: TypographyPresentationProps;
}

export const availableAtOtherShipToLabelStyles: AvailableAtOtherShipToLabelStyles = {
    wrapper: {
        css: css`
            display: flex;
        `,
    },
    text: {
        css: css`
            display: inline-flex;
            padding: ${pxToRem(2, 4)};
            background-color: ${getColor("common.accent")};
            border-radius: ${pxToRem(2)};
            font-size: ${x => x.theme.design.typography.size.tiny};
            font-weight: ${x => x.theme.design.typography.weight.base};
            line-height: ${x => x.theme.design.typography.lineHeight.small};
            color: ${getColor("text.light")};

            &::before {
                content: "";
                flex-shrink: 0;
                width: ${pxToRem(4)};
                height: ${pxToRem(4)};
                border-radius: 50%;
                background-color: currentColor;
                margin: ${pxToRem(6, 4, 0, 0)};
            }
        `,
    },
};

const AvailableAtOtherShipToLabel: FC<AvailableAtOtherShipToLabelProps> = ({ extendedStyles, overridedStyles }) => {
    const styles = useExpandProps(availableAtOtherShipToLabelStyles, extendedStyles, overridedStyles);

    return (
        <StyledWrapper as="span" {...styles.wrapper}>
            <Typography {...styles.text}>{translate("Available at other Ship to")}</Typography>
        </StyledWrapper>
    );
};

export default AvailableAtOtherShipToLabel;
